// src/services/taskPerformance.service.js
import { api } from './api';

class TaskPerformanceService {
    /**
     * Get performance stats
     */
    async getStats(period = 'weekly') {
        try {
            const response = await api.get(`/api/task-performance/stats?period=${period}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching performance stats:', error);
            throw error;
        }
    }

    /**
     * Get productivity metrics
     */
    async getProductivity(days = 30) {
        try {
            const response = await api.get(`/api/task-performance/productivity?days=${days}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching productivity metrics:', error);
            throw error;
        }
    }

    /**
     * Calculate and store performance stats
     */
    async calculateStats(periodData) {
        try {
            const response = await api.post('/api/task-performance/calculate', periodData);
            return response.data;
        } catch (error) {
            console.error('Error calculating stats:', error);
            throw error;
        }
    }

    /**
     * Get goals
     */
    async getGoals(filters = {}) {
        try {
            const params = new URLSearchParams();
            if (filters.status) params.append('status', filters.status);
            if (filters.goal_type) params.append('goal_type', filters.goal_type);

            const response = await api.get(`/api/task-performance/goals?${params.toString()}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching goals:', error);
            throw error;
        }
    }

    /**
     * Create goal
     */
    async createGoal(goalData) {
        try {
            const response = await api.post('/api/task-performance/goals', goalData);
            return response.data;
        } catch (error) {
            console.error('Error creating goal:', error);
            throw error;
        }
    }

    /**
     * Update goal
     */
    async updateGoal(goalId, goalData) {
        try {
            const response = await api.put(`/api/task-performance/goals/${goalId}`, goalData);
            return response.data;
        } catch (error) {
            console.error('Error updating goal:', error);
            throw error;
        }
    }

    /**
     * Delete goal
     */
    async deleteGoal(goalId) {
        try {
            const response = await api.delete(`/api/task-performance/goals/${goalId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting goal:', error);
            throw error;
        }
    }
}

export default new TaskPerformanceService();
